import script from "./ProductStatusCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStatusCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductStatusCard.vue?vue&type=style&index=0&id=167554a7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167554a7"]])

export default __exports__